<template>

	<div class="wrapper">
		<div class="section section-blogs-2 topsearch">
			<div class="container main">
				<div class="md-layout">
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">
						<div class="name">
							<h3 class="title title-right">Системные справочники</h3>
							<div class="md-layout">

								<div class="md-layout-item md-large-size-33 md-medium-size-50 md-small-size-100">
									<rotating-card
											:manual-rotate-state="false"
											manual-rotate>
										<template slot="frontRotateCardContent">
											<h5 class="card-category card-category-social text-primary">
												<i class="far fa-newspaper"></i> Справочник
											</h5>
											<h4 class="card-title">
												<a href="javascript:void(0)">Глобальные настройки</a>
											</h4>
											<p class="card-description">
												Содержит глобальные настройки
											</p>
											<div class="stats text-center">
												<router-link
														:to="{ name: 'configList', params: { dictCode: 'configList' } }"
														class="md-primary md-round"
														tag="md-button">
													<md-icon>refresh</md-icon>
													Просмотреть
												</router-link>
											</div>
										</template>
									</rotating-card>
								</div>

								<div class="md-layout-item md-large-size-33 md-medium-size-50 md-small-size-100">
									<rotating-card
											:manual-rotate-state="false"
											manual-rotate>
										<template slot="frontRotateCardContent">
											<h5 class="card-category card-category-social text-primary">
												<i class="far fa-newspaper"></i> Справочник
											</h5>
											<h4 class="card-title">
												<a href="javascript:void(0)">Каналы продаж</a>
											</h4>
											<p class="card-description">
												Содержит каналы продаж
											</p>
											<div class="stats text-center">
												<router-link :to="{ name: 'saleschannalList' }"
															 class="md-primary md-round"
															 tag="md-button">
													<md-icon>refresh</md-icon>
													Просмотреть
												</router-link>
											</div>
										</template>
									</rotating-card>
								</div>

								<div class="md-layout-item md-large-size-33 md-medium-size-50 md-small-size-100">
									<rotating-card
											:manual-rotate-state="false"
											manual-rotate>
										<template slot="frontRotateCardContent">
											<h5 class="card-category card-category-social text-primary">
												<i class="far fa-newspaper"></i> Справочник
											</h5>
											<h4 class="card-title">
												<a href="javascript:void(0)">LeadType</a>
											</h4>
											<p class="card-description">
												Содержит LeadType
											</p>
											<div class="stats text-center">
												<router-link :to="{ name: 'leadTypeList' }"
															 class="md-primary md-round"
															 tag="md-button">
													<md-icon>refresh</md-icon>
													Просмотреть
												</router-link>
											</div>
										</template>
									</rotating-card>
								</div>
								<div class="md-layout-item md-large-size-33 md-medium-size-50 md-small-size-100">
									<rotating-card
											:manual-rotate-state="false"
											manual-rotate>
										<template slot="frontRotateCardContent">
											<h5 class="card-category card-category-social text-primary">
												<i class="far fa-newspaper"></i> Справочник
											</h5>
											<h4 class="card-title">
												<a href="javascript:void(0)">Города</a>
											</h4>
											<p class="card-description">
												Содержит список доступных городов
											</p>
											<div class="stats text-center">
												<router-link
														:to="{ name: 'locationList', params: { dictCode: 'location' } }"
														class="md-primary md-round"
														tag="md-button">
													<md-icon>refresh</md-icon>
													Просмотреть
												</router-link>
											</div>
										</template>
									</rotating-card>
								</div>
								<div class="md-layout-item md-large-size-33 md-medium-size-50 md-small-size-100">
									<rotating-card
											:manual-rotate-state="false"
											manual-rotate>
										<template slot="frontRotateCardContent">
											<h5 class="card-category card-category-social text-primary">
												<i class="far fa-newspaper"></i> Справочник
											</h5>
											<h4 class="card-title">
												<a href="javascript:void(0)">Районы</a>
											</h4>
											<p class="card-description">
												Содержит список доступных районов
											</p>
											<div class="stats text-center">
												<router-link
														:to="{ name: 'districtList', params: { dictCode: 'disctrict' } }"
														class="md-primary md-round"
														tag="md-button">
													<md-icon>refresh</md-icon>
													Просмотреть
												</router-link>
											</div>
										</template>
									</rotating-card>
								</div>
								<div class="md-layout-item md-large-size-33 md-medium-size-50 md-small-size-100">
									<rotating-card
											:manual-rotate-state="false"
											manual-rotate>
										<template slot="frontRotateCardContent">
											<h5 class="card-category card-category-social text-primary">
												<i class="far fa-newspaper"></i> Справочник
											</h5>
											<h4 class="card-title">
												<a href="javascript:void(0)">SourceName</a>
											</h4>
											<p class="card-description">
												Содержит список доступных sourceName
											</p>
											<div class="stats text-center">
												<router-link
														:to="{ name: 'sourceNameList', params: { dictCode: 'sourcename' } }"
														class="md-primary md-round"
														tag="md-button">
													<md-icon>refresh</md-icon>
													Просмотреть
												</router-link>
											</div>
										</template>
									</rotating-card>
								</div>

								<div class="md-layout-item md-large-size-33 md-medium-size-50 md-small-size-100">
									<rotating-card
											:manual-rotate-state="false"
											manual-rotate>
										<template slot="frontRotateCardContent">
											<h5 class="card-category card-category-social text-primary">
												<i class="far fa-newspaper"></i> Справочник
											</h5>
											<h4 class="card-title">
												<a href="javascript:void(0)">Бизнес-Регионы</a>
											</h4>
											<p class="card-description">
												Содержит список Бизнес-Регионов
											</p>
											<div class="stats text-center">
												<router-link
														:to="{ name: 'bizregion', params: { dictCode: 'location' } }"
														class="md-primary md-round"
														tag="md-button">
													<md-icon>refresh</md-icon>
													Просмотреть
												</router-link>
											</div>
										</template>
									</rotating-card>
								</div>

								<div class="md-layout-item md-large-size-33 md-medium-size-50 md-small-size-100">
									<rotating-card
											:manual-rotate-state="false"
											manual-rotate>
										<template slot="frontRotateCardContent">
											<h5 class="card-category card-category-social text-primary">
												<i class="far fa-newspaper"></i> Справочник
											</h5>
											<h4 class="card-title">
												<a href="javascript:void(0)">Представительства</a>
											</h4>
											<p class="card-description">
												Содержит список доступных представительств
											</p>
											<div class="stats text-center">
												<router-link
														:to="{ name: 'office', params: { dictCode: 'location' } }"
														class="md-primary md-round"
														tag="md-button">
													<md-icon>refresh</md-icon>
													Просмотреть
												</router-link>
											</div>
										</template>
									</rotating-card>
								</div>

								<div class="md-layout-item md-large-size-33 md-medium-size-50 md-small-size-100">
									<rotating-card
											:manual-rotate-state="false"
											manual-rotate>
										<template slot="frontRotateCardContent">
											<h5 class="card-category card-category-social text-primary">
												<i class="far fa-newspaper"></i> Справочник
											</h5>
											<h4 class="card-title">
												<a href="javascript:void(0)">Территории представительств</a>
											</h4>
											<p class="card-description">
												Содержит список доступных территорий представительств
											</p>
											<div class="stats text-center">
												<router-link
														:to="{ name: 'territorie', params: { dictCode: 'location' } }"
														class="md-primary md-round"
														tag="md-button">
													<md-icon>refresh</md-icon>
													Просмотреть
												</router-link>
											</div>
										</template>
									</rotating-card>
								</div>

								<div class="md-layout-item md-large-size-33 md-medium-size-50 md-small-size-100">
									<rotating-card
											:manual-rotate-state="false"
											manual-rotate>
										<template slot="frontRotateCardContent">
											<h5 class="card-category card-category-social text-primary">
												<i class="far fa-newspaper"></i> Справочник
											</h5>
											<h4 class="card-title">
												<a href="javascript:void(0)">Параметры окон</a>
											</h4>
											<p class="card-description">
												Содержит параметры окон
											</p>
											<div class="stats text-center">
												<router-link :to="{ name: 'windowParamsList' }"
															 class="md-primary md-round"
															 tag="md-button">
													<md-icon>refresh</md-icon>
													Просмотреть
												</router-link>
											</div>
										</template>
									</rotating-card>
								</div>

								<div class="md-layout-item md-large-size-33 md-medium-size-50 md-small-size-100">
									<rotating-card
											:manual-rotate-state="false"
											manual-rotate>
										<template slot="frontRotateCardContent">
											<h5 class="card-category card-category-social text-primary">
												<i class="far fa-newspaper"></i> Справочник
											</h5>
											<h4 class="card-title">
												<a href="javascript:void(0)">Банеры</a>
											</h4>
											<p class="card-description">
												Содержит банеры
											</p>
											<div class="stats text-center">
												<router-link :to="{ name: 'bannersList' }" class="md-primary md-round"
															 tag="md-button">
													<md-icon>refresh</md-icon>
													Просмотреть
												</router-link>
											</div>
										</template>
									</rotating-card>
								</div>

								<div class="md-layout-item md-large-size-33 md-medium-size-50 md-small-size-100">
									<rotating-card
											:manual-rotate-state="false"
											manual-rotate>
										<template slot="frontRotateCardContent">
											<h5 class="card-category card-category-social text-primary">
												<i class="far fa-newspaper"></i> Справочник
											</h5>
											<h4 class="card-title">
												<a href="javascript:void(0)">FAQ</a>
											</h4>
											<p class="card-description">
												Содержит контент для вопрос-ответов
											</p>
											<div class="stats text-center">
												<router-link
														:to="{ name: 'DictionaryList', params: { dictCode: 'FAQ' } }"
														class="md-primary md-round"
														tag="md-button">
													<md-icon>refresh</md-icon>
													Просмотреть
												</router-link>
											</div>
										</template>
									</rotating-card>
								</div>

								<div class="md-layout-item md-large-size-33 md-medium-size-50 md-small-size-100">
									<rotating-card
											:manual-rotate-state="false"
											manual-rotate>
										<template slot="frontRotateCardContent">
											<h5 class="card-category card-category-social text-primary">
												<i class="far fa-newspaper"></i> Справочник
											</h5>
											<h4 class="card-title">
												<a href="javascript:void(0)">Модели окон</a>
											</h4>
											<p class="card-description">
												Содержит справочник моделей окон
											</p>
											<div class="stats text-center">
												<router-link
														:to="{ name: 'modelList', params: { dictCode: 'modelList' } }"
														class="md-primary md-round"
														tag="md-button">
													<md-icon>refresh</md-icon>
													Просмотреть
												</router-link>
											</div>
										</template>
									</rotating-card>
								</div>

								<div class="md-layout-item md-large-size-33 md-medium-size-50 md-small-size-100">
									<rotating-card
											:manual-rotate-state="false"
											manual-rotate>
										<template slot="frontRotateCardContent">
											<h5 class="card-category card-category-social text-primary">
												<i class="far fa-newspaper"></i> Справочник
											</h5>
											<h4 class="card-title">
												<a href="javascript:void(0)">Мансардные окна</a>
											</h4>
											<p class="card-description">
												Содержит справочник моделей мансардных окон
											</p>
											<div class="stats text-center">
												<router-link
														:to="{ name: 'modelListRoof', params: { dictCode: 'modelListRoof' } }"
														class="md-primary md-round"
														tag="md-button">
													<md-icon>refresh</md-icon>
													Просмотреть
												</router-link>
											</div>
										</template>
									</rotating-card>
								</div>

								<div class="md-layout-item md-large-size-33 md-medium-size-50 md-small-size-100">
									<rotating-card
											:manual-rotate-state="false"
											manual-rotate>
										<template slot="frontRotateCardContent">
											<h5 class="card-category card-category-social text-primary">
												<i class="far fa-newspaper"></i> Справочник
											</h5>
											<h4 class="card-title">
												<a href="javascript:void(0)">Справочники (калькулятор)</a>
											</h4>
											<p class="card-description">
												Содержит справочники для калькулятора
											</p>
											<div class="stats text-center">
												<router-link
														:to="{ name: 'calcdictList', params: { dictCode: 'calcdictList' } }"
														class="md-primary md-round"
														tag="md-button">
													<md-icon>refresh</md-icon>
													Просмотреть
												</router-link>
											</div>
										</template>
									</rotating-card>
								</div>


								<div class="md-layout-item md-large-size-33 md-medium-size-50 md-small-size-100">
									<rotating-card
											:manual-rotate-state="false"
											manual-rotate>
										<template slot="frontRotateCardContent">
											<h5 class="card-category card-category-social text-primary">
												<i class="far fa-newspaper"></i> Справочник
											</h5>
											<h4 class="card-title">
												<a href="javascript:void(0)">Типы помещений</a>
											</h4>
											<p class="card-description">
												Содержит типы помещений
											</p>
											<div class="stats text-center">
												<router-link :to="{ name: 'roomList'}" class="md-primary md-round"
															 tag="md-button">
													<md-icon>refresh</md-icon>
													Просмотреть
												</router-link>
											</div>
										</template>
									</rotating-card>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
    import { validationMixin } from 'vuelidate'
    import moment from 'moment'
    import {
        required,
        email,
        minLength,
        maxLength,
    } from 'vuelidate/lib/validators'

    import RotatingCard from '@/components/RotatingCard'

    export default {
        mixins: [
            validationMixin,
        ],
        components: {
            'rotating-card': RotatingCard,
        },
        bodyClass: 'reports-list',
        data () {
            return {
                clientsPortalURL: '',
                locale: {
                    startYear: 1900,
                    endYear: 2099,
                    dateFormat: 'dd.MM.yyyy',
                    days: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
                    shortDays: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
                    shorterDays: ['В', 'П', 'В', 'С', 'Ч', 'П', 'С'],
                    months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                    shortMonths: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июнь', 'Июль', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
                    shorterMonths: ['Я', 'Ф', 'М', 'А', 'М', 'Ин', 'Ил', 'А', 'С', 'О', 'Н', 'Д'],
                    firstDayOfAWeek: 1,
                },
                rep1: {
                    repDate: null,
                    salesOffice: null,
                },
                salesOffices: [],
                validations: {
                    rep1: {
                        salesOffice: {
                            required,
                        },
                    },
                },
            }
        },
        created () {
        },
        mounted () {
            this.$material.locale = this.locale
        }
    }
</script>
<style lang="scss" scoped>
	.btnsep {
		margin-top: 30px;
	}

	.title-right {
		text-align: right;
	}
</style>
